import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal.component';
import { InputModule, TextAreaModule } from '@components/form-group/index';

@NgModule({
  declarations: [ModalComponent],
  imports: [
    CommonModule,
    InputModule,
    TextAreaModule
  ],
  exports: [ModalComponent]
})
export class ModalModule { }
